import axios from 'axios'

export default {
    async oauth(auth_code) {
        try {
            const response = await axios.post('/api/oauth', {code: auth_code});
            if (response.status === 204) {
                return Promise.resolve(true);
            } else {
                return Promise.reject(false);
            }
        } catch (e) {
            return Promise.reject(e.message);
        }
    },
    checkAuth() {
        return axios.get('/api/check_auth', {skipAuthInterceptor: true});
    },
    logout() {
        return axios.get('/api/logout');
    }
}
